import styles from './CategoriesGrid1SSkeleton.module.scss';

const TILES = ['tile-1', 'tile-2', 'tile-3', 'tile-4'];

/**
 * Loading skeleton for the CategoriesGrid1S block: a section title followed by
 * a row of large rounded category tiles (carousel on desktop, 2-column grid on mobile).
 */
export const CategoriesGrid1SSkeleton = () => {
  return (
    <div className={styles.root}>
      <div className={styles.title} />
      <div className={styles.grid}>
        {TILES.map((key) => (
          <div key={key} className={styles.tile} />
        ))}
      </div>
    </div>
  );
};
